import { AppealDetailConsultation } from 'feature/appeals/view'
import { MainLayout } from 'layouts'

export function AppealConsultation() {
  return (
    <MainLayout>
      <div className='container'>
        <AppealDetailConsultation />
      </div>
    </MainLayout>
  )
}
